import React from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';

import { resolveLandingViewMode } from './landingViewMode';
import AssetMarketBrowse from './AssetMarketBrowse';

import css from './LandingAssetMarket.module.css';

/**
 * Asset market panel — Craigslist-style browse on /marketplace, compact preview on home dual pane.
 */
const LandingAssetMarket = props => {
  const { className, rootClassName, variant } = props;
  const { pathname } = useLocation();
  const viewMode = variant || resolveLandingViewMode(pathname);
  const compact = viewMode === 'home';

  return (
    <AssetMarketBrowse
      className={classNames(className, css.wrapper)}
      rootClassName={rootClassName || css.root}
      compact={compact}
    />
  );
};

export default LandingAssetMarket;
